export default __webpack_public_path__ + "static/media/bannerFooterResponsive.3a2ab78c.png";